export default __webpack_public_path__ + "static/media/paypal.dbd09b0a.svg";